import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField,
  Grid,
  Select,
  Typography,
  Stack,
  AppBar,
  Toolbar,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { AsyncPaginate } from "react-select-async-paginate";
import customStyles from "app/shared-components/SelectCustomStyle";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { clearAbsData } from "app/store/absSlice";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
const newLinkOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newLinkOrder}`;
const searchCommissionUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;

export const AbLinkOrder = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { setLinkOrderStatus, setOpenLinkOrder } = props;
  const [open, setOpen] = useState(true);
  const { absData, hasAbsData } = useSelector((state) => state.abs);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentQuery, setCurrentQuery] = useState("");
  const [error, setError] = useState();
  const [selectedCommissionNumber, setSelectedCommissionNumber] =
    useState(null);
  const [abNumber, setAbNumber] = useState(null);
  const [abFileId, setAbFileId] = useState("");
  const [orderId, setOrderId] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const baseStyles = customStyles();
  const selectStyles = {
    ...baseStyles,
    menu: (base) => ({
      ...base,
      maxHeight: 300,
      overflowY: "auto",
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    }),
    option: (base, state) => ({
      ...(baseStyles.option ? baseStyles.option(base, state) : base),
      whiteSpace: "normal",
      wordBreak: "break-word",
    }),
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedCommissionNumber(null);
    setAbNumber(null);
    setCurrentPage(0);
    setOpenLinkOrder(false);
    setLinkOrderStatus(false);
  };

  const getCommissionOptions = async (query, page) => {
    const size = 30;
    if (query !== currentQuery) {
      setCurrentPage(0);
      page = 0;
      setCurrentQuery(query);
    }
    const result = await getCommissionName(query, page, size);

    if (result.hasMore) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
    return result;
  };
  const getCommissionName = async (query, page, size) => {
    try {
      let url = searchCommissionUrl;
      if (query) {
        let searchQuery = `.*${query.toUpperCase()}.*`;
        url += `/search/findForABLinking?commissionName=${searchQuery}&page=${page}&size=${size}&sort=createdDate,desc`;
      } else {
        let searchQuery = `.*`;
        url += `/search/findForABLinking?commissionName=${searchQuery}&page=${page}&size=${size}&sort=createdDate,desc`;
      }
      let list = await OAuthService.getList(url);
      const data = list.data?._embedded?.orders;
      const newArray = data?.map((obj) => {
        for (const key in obj) {
          if (
            (obj.hasOwnProperty(key) && obj[key] === undefined) ||
            obj[key] === null ||
            obj[key] === "" ||
            obj[key] === 0
          ) {
            obj[key] = "";
          }
        }
        return obj;
      });
      return {
        options: newArray,
        hasMore: newArray.length >= 1,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleCommissionChange = (option) => {
    setError();
    setSelectedCommissionNumber(option);
    setOrderId(option?.id);
  };
  const handleLinkOrder = async () => {
    if (!orderId || !abFileId) {
      toast.error("Order ID and AB File ID are required.");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("orderId", orderId);
      formData.append("abFileId", abFileId);
      const response = await OAuthService.addData(newLinkOrderUrl, formData);

      const data = response.data;
      if (data) {
        toast.success("Order linked successfully!");
        setLinkOrderStatus(true);
        setOpenLinkOrder(false);
        handleClose();
        dispatch(clearAbsData());
      }
    } catch (error) {
      console.error("Error linking order:", error);
      setOpenLinkOrder(false);
      toast.error(
        error?.response?.data?.errorMessage ||
          error.message ||
          "Something went wrong.",
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (absData) {
      setAbNumber(absData.abNumber);
      setAbFileId(absData.id);
    }
  }, [absData]);

  return (
    <Dialog
      open={open}
      fullWidth
      fullScreen={isMobile}
      maxWidth="xl"
      onClose={handleClose}
      sx={{ overflowY: "auto" }}
    >
      <AppBar position="static">
        <Toolbar className="flex w-full justify-between">
          <Typography variant="subtitle1" color="inherit">
            Link AB to an Order
          </Typography>
          <Button onClick={handleClose} autoFocus color="inherit">
            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
          </Button>
        </Toolbar>
      </AppBar>
      <DialogContent classes={{ root: "p-16 sm:p-24" }}>
        <DialogContentText
          component="div"
          sx={{ color: theme.palette.text.primary }}
        >
          <Typography component="h2">
            Please choose the Commission Name to link the AB
          </Typography>

          <Grid container spacing={2} className="mt-2 mb-[200px]">
            <Grid item xs={12} sm={4} md={3}>
              <label className="pb-8 block">AB No</label>
              <TextField
                name="customer"
                fullWidth
                variant="outlined"
                type="text"
                value={abNumber ?? ""}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={8} md={6}>
              <label className="pb-8 block">Commission Name</label>
              <AsyncPaginate
                value={selectedCommissionNumber}
                loadOptions={(inputValue, _, { page }) =>
                  getCommissionOptions(inputValue, page)
                }
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => {
                  const date = new Date(
                    option.createdDate,
                  ).toLocaleDateString();
                  return `${option.commissionName} -- ${
                    option.orderCategory
                  } -- ${date}${
                    option.abNumber ? ` [${option.abNumber}]` : ""
                  }`;
                }}
                onChange={handleCommissionChange}
                styles={selectStyles}
                className="w-full"
                isSearchable
                additional={{ page: currentPage }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Box sx={{ mt: { xs: 0, md: 3.5 } }}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleLinkOrder}
                  fullWidth={isMobile}
                  sx={{ mx: { xs: 0, md: 1 } }}
                  disabled={loading || !selectedCommissionNumber}
                >
                  Link Order
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
